import { ApiService } from './api/api'
import { processParams } from '@/utils/params'

export default class ProductGroupService {
	private apiService

	constructor() {
		this.apiService = new ApiService(true)
	}

	/**
	 * Get all product groups
	 * @returns Promise
	 */
	getAll(params?: Record<string, string | string[]>): Promise<any> {
		return this.apiService.get(`/product-groups`, { params: processParams(params) })
	}

	/**
	 * Get a product group
	 * @param code String
	 * @param params Record<string, string | string[]
	 * @returns Promise
	 */
	get(code: string, params?: Record<string, string | string[]>): Promise<any> {
		return this.apiService.get(`/product-groups/${code}`, { params: processParams(params) })
	}
}
